"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = require("react");

/**
 * A hook to replace ye olde `this._isMounted`. Check this value before setting state after a
 * timeout, if it isn't practical to clear that timeout on unmount.
 *
 * @returns A ref with the value `true` if this component is mounted, `false` otherwise
 */
function _default() {
  var mounted = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return mounted;
}

module.exports = exports.default;